import { calcNbrMonthsBtwnDates } from "../../../objects/CommonUse/nbr_months_btwn_dates_calc";

export const calcProtectPlanPaidAmt = (addTrans, gameDate) => {
    let totalAmtPaidArr = [];
    let prevTranAmt = "";
    let prevProtectPlanType = "";
    let prevPlanName = "";
    let saveFirstDate = "";
    let addTransArr = [];
    for (let i=0; i<addTrans.length; i++){
        if (addTrans[i].protectPlanType !== prevProtectPlanType || addTrans[i].planName !== prevPlanName){
            if (prevProtectPlanType !== ""){
                const addTranObj = {protectPlanType: prevProtectPlanType, planName: prevPlanName, addFirstDate: saveFirstDate, 
                    addLastDate: addTrans[i].tranDate, tranAmt: prevTranAmt, totalSaved: 0 };
                addTransArr.push(addTranObj);
            }
            prevProtectPlanType = addTrans[i].protectPlanType;
            prevTranAmt = addTrans[i].tranAmount;
            prevPlanName = addTrans[i].planName;
            saveFirstDate = addTrans[i].tranDate;
        }
    }
    if (prevProtectPlanType !== ""){
        const addTranObj = {protectPlanType: prevProtectPlanType, planName: prevPlanName, addFirstDate: saveFirstDate, 
            addLastDate: gameDate, tranAmt: prevTranAmt, totalSaved: 0 };
        addTransArr.push(addTranObj);
    }
    for (let i=0; i<addTransArr.length; i++){
        const nbrMonths = calcNbrMonthsBtwnDates(addTransArr[i].addFirstDate, addTransArr[i].addLastDate);
        const totalPaid = (+nbrMonths * +addTransArr[i].tranAmt * -1).toFixed(2);
        const paidObj = {...addTransArr[i], totalPaid: totalPaid};
        totalAmtPaidArr.push(paidObj);
    }
    return totalAmtPaidArr;
}
export default calcProtectPlanPaidAmt;